require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-vw-ws-u.json") })
        }
      }, "path---photos-professional-vw-ws-u");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-vw-ws-u!./.cache/json/photos-professional-vw-ws-u.json
// module id = 937
// module chunks = 231608221292675